export default {
    NEW_POS_EMAILS: { name: 'NEW_POS_EMAILS' },
    SIM_EMAILS: { name: 'SIM_EMAILS' }
};